export const CHAT = '/api/chat';
